module.exports = __webpack_public_path__ + "img/imagen_secretario.add3b212.jpg";